import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    viewBox="0 0 64 64"
    ref={svgRef}
    {...props}
  >
    <mask
      id="send_svg__a"
      style={{
        maskType: "alpha",
      }}
      width={64}
      height={64}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
    >
      <path fill="currentColor" d="M0 0h64v64H0z" />
    </mask>
    <g mask="url(#send_svg__a)">
      <path
        fill="currentColor"
        d="M11.733 51.8c-.889.356-1.733.278-2.533-.233-.8-.511-1.2-1.256-1.2-2.234v-12L29.333 32 8 26.667v-12c0-.978.4-1.723 1.2-2.234.8-.51 1.644-.589 2.533-.233L52.8 29.533c1.111.49 1.667 1.311 1.667 2.467 0 1.156-.556 1.978-1.667 2.467L11.733 51.8z"
      />
    </g>
  </Icon>
));
